import PropTypes from "prop-types";
import CatalogNativeSelect from "./CatalogNativeSelect";

/**
 * Native select styled like toolbar filters in manutenzione cataloghi (cm-toolbar-stato).
 */
const CatalogToolbarSelect = ({
  className = "",
  menuClassName = "",
  ...props
}) => (
  <CatalogNativeSelect
    className={["cm-toolbar-stato", className].filter(Boolean).join(" ")}
    menuClassName={menuClassName}
    {...props}
  />
);

CatalogToolbarSelect.propTypes = {
  ...CatalogNativeSelect.propTypes,
  className: PropTypes.string,
  menuClassName: PropTypes.string,
};

export default CatalogToolbarSelect;
